export const careerFields = (attrs) => {
  const a = attrs || {};
  const employment = a.employmentType || "";

  return [
    {
      name: "position",
      label: "Назва вакансії / Позиція",
      type: "text",
      required: true,
      placeholder: "Наприклад: Продавець, Бариста, Frontend Developer",
    },
    {
      name: "employmentType",
      label: "Тип зайнятості",
      type: "select",
      options: [
        "Повна зайнятість",
        "Неповна зайнятість",
        "Підробіток",
        "Сезонна робота",
        "Стажування",
        "Волонтерство",
      ],
    },
    {
      name: "schedule",
      label: "Графік роботи",
      type: "select",
      options: [
        "Повний день",
        "Позмінно",
        "Гнучкий графік",
        "Віддалено",
        "Інше",
      ],
    },
    {
      name: "salary",
      label: "Зарплата (грн)",
      type: "number",
      step: "100",
      placeholder: "Наприклад: 15000",
      showIf: (st) => st.employmentType !== "Волонтерство",
    },
    {
      name: "salaryType",
      label: "Формат оплати",
      type: "select",
      options: ["Місяць", "Тиждень", "День", "Година", "За домовленістю"],
      showIf: (st) => st.employmentType !== "Волонтерство",
    },
  ];
};
